import { ApiDialogService } from './../../../services/api/api-cdialog.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogAppearance, DialogTypeEnum, DialogVariant, IDialogConfirm } from 'src/app/models/dialog';
import { FormControl, Validators } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-c-dialog',
  templateUrl: './c-dialog.component.html',
  styleUrls: ['./c-dialog.component.scss']
})
export class CDialogComponent implements OnInit {
  control = new FormControl<string>('', [Validators.required]);

  DialogTypeEnum = DialogTypeEnum;
  dialogType = this.data?.type;

  safeTitle!: SafeHtml;
  safeTextInit!: SafeHtml;
  safeBoldTitle!: SafeHtml;
  appearance: DialogAppearance = 'legacy';
  variant: DialogVariant = 'default';

  get isBatchPreview(): boolean {
    return this.variant === 'batch-preview';
  }

  get isDestructive(): boolean {
    const content = `${this.data?.template?.boldTitle ?? ''} ${this.data?.template?.title ?? ''}`.toLowerCase();
    return content.includes('excluir') || content.includes('remover') || content.includes('apagar');
  }

  get eyebrowText(): string {
    if (this.isBatchPreview) {
      return 'Gerar Automático';
    }

    if (this.isDestructive) {
      return 'Confirmar exclusão';
    }

    if (this.dialogType === DialogTypeEnum.OptionalWithField) {
      return 'Confirmar ação';
    }

    return 'Confirmação';
  }

  get supportingText(): string {
    if (this.data?.template?.description) {
      return this.data.template.description;
    }

    if (this.isBatchPreview) {
      return 'Confirme para iniciar a geração automática dos lotes.';
    }

    if (this.isDestructive) {
      return 'Esta ação não pode ser desfeita.';
    }

    return '';
  }

  get showSupportingText(): boolean {
    return !!this.data?.template?.description || this.isBatchPreview || this.isDestructive;
  }

  constructor(
    public dialogRef: MatDialogRef<CDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDialogConfirm,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.appearance = this.data?.appearance ?? 'legacy';
    this.variant = this.data?.variant ?? 'default';
    this.safeTitle = this.sanitizer.bypassSecurityTrustHtml(this.data?.template?.title ?? '');
    this.safeTextInit = this.sanitizer.bypassSecurityTrustHtml(this.data?.template?.textInit ?? '');
    this.safeBoldTitle = this.sanitizer.bypassSecurityTrustHtml(this.data?.template?.boldTitle ?? '');
  }

  close(action: boolean): void {
    if (this.dialogType === DialogTypeEnum.OptionalWithField && action) {
      this.control.markAsDirty();

      if (this.control.valid) {
        this.dialogRef.close(this.control.value);
      }
    } else {
      this.dialogRef.close(action);
    }
  }
}
